import logEvent from "./log-event"

const eventAttributes = {
  source_page_referrer: document.referrer,
  page_title: document.title,
  url: window.location.href,
}

logEvent("homepage_viewed", eventAttributes)
